// extracted by mini-css-extract-plugin
export default {"scs_fallback_container":"scs_fallback_container","fallback_img":"fallback_img"};